module.exports = __webpack_public_path__ + "static/home-hero-55fbcf9a02acd10b1c2e273ace3e3bbf.svg";